module.exports = __webpack_public_path__ + "img/bg.52112cb8.jpeg";